export default __webpack_public_path__ + "static/media/vehicle-monitoring.92b8b12d.jpg";